module.exports = __webpack_public_path__ + "images/facebook_icon.c6152293.png";